// extracted by mini-css-extract-plugin
module.exports = {"form":"accountManagement_form__1GFAJ"};